<template>
  <div class="bg-white flex flex-col p-4 rounded" v-loading="loading">
    <div>
      <el-button type="text" @click="cancel" icon="el-icon-arrow-left"
        >Back to Backup and Restore</el-button
      >
    </div>
    <hr class="my-4" />
    <div id="form-container" class="pt-2">
      <el-form
        ref="elForm"
        :model="formData"
        :rules="validationRules"
        @submit.native.prevent="submit"
        size="medium"
        label-width="auto"
      >
        <el-form-item label="Backup directory" prop="BackupDirectory">
          <el-input
            v-model="formData.BackupDirectory"
            placeholder="/data/backup"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <div class="flex flex-col">
            <el-checkbox
              v-model="formData.TypeOne"
              label="Fail if not mounted remotely"
              name="typeOne"
            ></el-checkbox>
            <el-checkbox
              v-model="formData.TypeTwo"
              label="Enable backup clean up"
              name="typeTwo"
            ></el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="Number of days to keep each backup" prop="Number">
          <el-input
            v-model="formData.Number"
            placeholder="30"
            clearable
          ></el-input>
        </el-form-item>

        <hr class="my-4" />
        <div class="w-full text-right">
          <el-button type="primary" @click="submit" plain
            >Save Settings</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import formService from '@/mixins/FormService'
import formHelper from './form-helper'

let service

export default {
  components: {},
  created() {
    service = new formService(this, formHelper)
  },
  async mounted() {
    this.loading = true
    this.formData = await service.initialFormData()
    this.loading = false
  },
  data() {
    return {
      apiGetById: this.$appInfo.api.version.getById,
      apiPost: this.$appInfo.api.version.post,
      apiPut: this.$appInfo.api.version.put,
      formData: formHelper.getEmptyData(),
      validationRules: formHelper.getValidationRule(),
      loading: false
    }
  },
  methods: {
    async cancel() {
      this.$router.go(-1)
    },
    async submit() {
      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.isSubmit = true

            // convert value type
            // this.formData.ParentId = parseInt(this.formData.ParentId)
            // this.formData.OrderSort = parseInt(this.formData.OrderSort)

            // submit data
            await service.submit(this.formData)

            this.$message.success('Data Saved')
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e)
            console.log(e)
          }
        } else {
          this.$message.warning('Please fill in the required data')
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
